export enum IdentityProviderType {
    LoginCredentials = 1,
    OidcOkta = 2,
    AzureAD = 3,
    Google = 4,
}